// import { pc_mode_img } from 'logo.svg'
import React, { useEffect } from "react";
import "./index.scss";

const pc = () => {
  console.log("window.innerHeight", window.innerHeight);
  console.log("window.innerWidth", window.innerWidth);
  document.body.classList.add("bgr-blue");
  document.body.classList.remove("bgr-game");
  // useEffect(() => {
  //   document.body.classList.add("bgr-blue");
  //   document.body.classList.remove("bgr-game");
  // }, []);
  return (
    <div
      style={{
        backgroundColor: "var(--colorPrimary)",
        height: window.innerHeight,
        overflow: "hidden",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <img
        src={"assets/img/desktop.png"}
        style={{
          width: "auto",
          height: window.innerHeight,
          objectFit: "contain",
        }}
      />
    </div>
  );
};
export default pc;
